import {
  GetTimeSettingsCustomTimeRangeCategoriesDocument,
  UpdateTimeSettingsCustomTimeRangeCategoryDocument,
  UpdateTimeSettingsCustomTimeRangeCategoryMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateCustomTimeRangeCategory = () => {
  const [updateTimeSettingsCustomTimeRangeCategory, { loading }] = useMutation(
    UpdateTimeSettingsCustomTimeRangeCategoryDocument,
    {
      extractorFn: (data) => data.timeSettingsMutations.updateTimesettingsCustomTimeRangeCategory,
    }
  )

  const update = (variables: UpdateTimeSettingsCustomTimeRangeCategoryMutationVariables) => {
    return updateTimeSettingsCustomTimeRangeCategory({
      variables,
      refetchQueries: [GetTimeSettingsCustomTimeRangeCategoriesDocument],
    })
  }

  return {
    loading,
    update,
  }
}
